import React from 'react';
import RegistrationFormContent from '../Components/Registration/';
import PublicLayout from '../Layouts/PublicLayout';

export default function RegistrationForm() {
  return (
    <PublicLayout>
        <div className='public-row mx-auto'>
          <RegistrationFormContent />
        </div>
    </PublicLayout>
  )
}
